import api from '@pray/shared/utils/api';

export async function getWorkflowAISettings({ artistId }) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/settings/workflow-ai`;
  const response = await api.executeGetRequest(url);

  return response.data.data;
}
